import { render, staticRenderFns } from "./editor-form.vue?vue&type=template&id=5ac62492&"
import script from "./editor-form.vue?vue&type=script&lang=js&"
export * from "./editor-form.vue?vue&type=script&lang=js&"
import style0 from "./editor-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports